export default "__VITE_ASSET__BQq_tWs$__"